import { render } from "./BusinessTransferUpdate.vue?vue&type=template&id=5dccc1db"
import script from "./BusinessTransferUpdate.vue?vue&type=script&lang=js"
export * from "./BusinessTransferUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__